import config from '@/config/index'

/**
 * 易甄学主站：仅这些域名展示 AI 客服悬浮栏、页脚「联系我们/友情链接」等主站扩展
 * 培训店 / 西电 / 其它分站一律不展示
 */
export const MAIN_SHOP_HOSTS = [
  'edu.shanxiyixue.com',
  'edu-test.ykumda.com',
]

function normalizeHost(host) {
  if (!host) return ''
  return String(host).split(':')[0].toLowerCase()
}

export function isMainShopHost(host) {
  return MAIN_SHOP_HOSTS.includes(normalizeHost(host))
}

function isDevEnv() {
  try {
    if (typeof import.meta !== 'undefined' && import.meta.dev) {
      return true
    }
  } catch (e) {}
  return process.env.NODE_ENV === 'development'
}

/** 是否像本地/内网访问（非真实店铺域名） */
function isLocalLikeHost(host) {
  const h = normalizeHost(host)
  if (!h) return true
  if (h === 'localhost' || h === '127.0.0.1' || h.endsWith('.local')) {
    return true
  }
  // 局域网
  if (/^192\.168\.\d+\.\d+$/.test(h)) return true
  if (/^10\.\d+\.\d+\.\d+$/.test(h)) return true
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d+\.\d+$/.test(h)) return true
  return false
}

/**
 * 是否展示主站扩展（AI / 页脚联系区）
 * @param {string} [host] 当前访问 hostname；本地开发可为空，会回落到 config.url
 */
export function showMainShopExtras(host) {
  const h = normalizeHost(host)
  if (isMainShopHost(h)) {
    return true
  }
  // 生产：严格按真实域名，不用 config.url（避免分站误开）
  if (!isDevEnv()) {
    return false
  }
  // 开发：已用 hosts/代理打开真实店铺域名时，严格按 hostname（上面已判过白名单）
  if (h && (h.endsWith('.shanxiyixue.com') || h.endsWith('.ykumda.com') || h.endsWith('.4e-edu.cn'))) {
    return false
  }
  // 开发：localhost / 局域网 → 按 config.url 模拟易甄学主站
  if (isLocalLikeHost(h)) {
    return isMainShopHost(config.url)
  }
  return false
}
